import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDeployAuth } from "../../context/DeployAuthContext";

const STORAGE_PREFIX = "rivieradeploy_banner_dismissed_";

/**
 * RD-0771 — operator banner for all /deploy routes; dismiss persists per sessionStorage fingerprint.
 */
function DeployMaintenanceBannerStrip() {
  const location = useLocation();
  const { dashboardBanner, isLoading } = useDeployAuth();
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (!dashboardBanner || !dashboardBanner.fingerprint) {
      setDismissed(false);
      return;
    }
    try {
      const v = sessionStorage.getItem(STORAGE_PREFIX + dashboardBanner.fingerprint) === "1";
      setDismissed(v);
    } catch (e) {
      console.warn(`[${new Date().toISOString()}] [DeployMaintenanceBannerStrip] sessionStorage`, e?.message);
    }
  }, [dashboardBanner]);

  if (!location.pathname.startsWith("/limelite/deploy") || isLoading || !dashboardBanner || dismissed) {
    return null;
  }

  const { text, severity, linkUrl, fingerprint } = dashboardBanner;
  const border =
    severity === "incident"
      ? "border-red-800/80 bg-red-950/40"
      : severity === "warning"
        ? "border-amber-800/80 bg-amber-950/35"
        : "border-blue-900/60 bg-slate-900/80";

  const dismiss = () => {
    try {
      sessionStorage.setItem(STORAGE_PREFIX + fingerprint, "1");
    } catch (e) {
      console.warn(`[${new Date().toISOString()}] [DeployMaintenanceBannerStrip] dismiss store failed`, e?.message);
    }
    setDismissed(true);
  };

  return (
    <div className={`border-b px-4 py-3 text-sm text-slate-100 ${border}`} role="status">
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3">
        <div>
          <p className="font-medium text-slate-50">
            {severity === "incident" && "Incident / degradation"}
            {severity === "warning" && "Maintenance notice"}
            {severity === "info" && "Notice"}
          </p>
          <p className="text-slate-200/90 mt-1 whitespace-pre-wrap">{text}</p>
          {linkUrl ? (
            <a
              className="inline-block mt-2 text-blue-400 hover:underline text-sm"
              href={linkUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              Status or details
            </a>
          ) : null}
        </div>
        <button
          type="button"
          onClick={dismiss}
          className="shrink-0 text-sm border border-slate-600 hover:border-slate-400 text-slate-200 px-3 py-1.5 rounded self-start"
        >
          Dismiss for this session
        </button>
      </div>
    </div>
  );
}

export default DeployMaintenanceBannerStrip;
